module.exports = __webpack_public_path__ + "fonts/fa-regular-400.983a20d2.woff2";